import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Axios from 'axios';

import { BackDropLoad } from './LoadingBackDrop';
import { QuickSearch } from './QuickSearch';
import { UserContext, SnackbarContext } from './userContext';
import { Skeleton } from '../theme/primitives';

/* ─────────── Inline icons ─────────── */
const I = {
  List:        ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  Book:        ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>,
  Trend:       ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
  Ruler:       ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M3 17 17 3l4 4L7 21z"/><path d="M7 17l3-3M11 13l3-3M15 9l3-3"/></svg>,
  Briefcase:   ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>,
  Search:      ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>,
  User:        ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  ChevronDown: ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="m6 9 6 6 6-6"/></svg>,
  ChevronRight:({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="m9 18 6-6-6-6"/></svg>,
  Menu:        ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>,
  Close:       ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M18 6 6 18M6 6l12 12"/></svg>,
  Logout:      ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  Lock:        ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  Edit:        ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>,
  Users:       ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  History:     ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l3 2"/></svg>,
  ArrowUp:     ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>,
  Card:        ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><rect x="2" y="6" width="20" height="14" rx="2"/><path d="M2 11h20"/></svg>,
  Bookmark:    ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>,
  CheckCircle: ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
  Switch:      ({ className }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden><path d="M16 3h5v5"/><path d="M4 20l16.2-16.2"/><path d="M21 16v5h-5"/><path d="M15 15l6 6"/><path d="M4 4l5 5"/></svg>,
};

/* ─────────── helpers ─────────── */
function matchesAny(pathname, patterns) {
  return patterns.some((p) =>
    p.endsWith('*') ? pathname.startsWith(p.slice(0, -1)) : pathname === p,
  );
}

/* ─────────── desktop NavLink ─────────── */
function DesktopNav({ children, to, onClick, isActive, IconCmp, hasCaret, ariaExpanded, ariaHasPopup }) {
  const Tag = to ? Link : 'button';
  const props = to ? { to } : { type: 'button' };
  return (
    <Tag
      {...props}
      onClick={onClick}
      aria-expanded={ariaExpanded}
      aria-haspopup={ariaHasPopup}
      className={`
        group relative inline-flex items-center gap-1.5 rounded-lg px-3 h-10
        text-[13px] font-semibold leading-none
        transition-[color,background-color] duration-200 ease-out-soft
        ${isActive
          ? 'text-amber'
          : 'text-fg-secondary hover:text-amber'}
      `}
    >
      {IconCmp && <IconCmp className="h-4 w-4" />}
      <span>{children}</span>
      {hasCaret && (
        <I.ChevronDown
          className={`h-3.5 w-3.5 transition-transform duration-200 ${ariaExpanded === 'true' ? 'rotate-180' : ''}`}
        />
      )}
      <span
        aria-hidden
        className={`
          pointer-events-none absolute left-1/2 bottom-1 h-[2px] -translate-x-1/2 rounded-full
          transition-[width] duration-200 ease-out-soft
          ${isActive ? 'w-7 bg-amber' : 'w-0 bg-amber group-hover:w-5'}
        `}
        style={{ boxShadow: isActive ? '0 0 8px rgba(251,191,36,0.6)' : undefined }}
      />
    </Tag>
  );
}

/* ─────────── popover (categories / account) ─────────── */
function Popover({ open, anchor, onClose, children, align = 'left' }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target) && anchor && !anchor.contains(e.target)) {
        onClose();
      }
    };
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open, anchor, onClose]);

  if (!open || !anchor) return null;

  const rect = anchor.getBoundingClientRect();
  const style = align === 'right'
    ? { top: rect.bottom + 8, right: window.innerWidth - rect.right }
    : { top: rect.bottom + 8, left: rect.left };

  return (
    <div
      ref={ref}
      role="menu"
      style={{ position: 'fixed', ...style, zIndex: 1100 }}
      className="
        min-w-[240px] max-w-[320px] max-h-[70vh] overflow-y-auto
        rounded-2xl border border-amber/24 bg-surface-paper
        shadow-dialog
        animate-[fadeIn_180ms_ease-out]
        py-2
      "
    >
      <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/60 to-transparent" />
      {children}
    </div>
  );
}

function PopoverItem({ to, onClick, IconCmp, children, danger }) {
  const Tag = to ? Link : 'button';
  const props = to ? { to } : { type: 'button' };
  return (
    <Tag
      {...props}
      role="menuitem"
      onClick={onClick}
      className={`
        flex w-full items-center gap-2.5 px-3 py-2 text-left
        text-[13px] font-medium
        transition-[background-color,color] duration-150 ease-out-soft
        ${danger
          ? 'text-red-400 hover:bg-red-400/10'
          : 'text-fg-secondary hover:bg-amber/10 hover:text-amber'}
      `}
    >
      {IconCmp && (
        <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md ${danger ? 'bg-red-400/10' : 'bg-amber/10 text-amber'}`}>
          <IconCmp className="h-3.5 w-3.5" />
        </span>
      )}
      <span className="truncate">{children}</span>
    </Tag>
  );
}

/* ─────────── account items builder ─────────── */
function buildAccountItems(user, onClose, logout) {
  const items = [];
  if (!user) {
    items.push(
      { key: 'login', to: '/login', IconCmp: I.User, label: 'Login' },
      { key: 'signup', to: '/signup', IconCmp: I.User, label: 'Sign up' },
    );
    return items;
  }

  if (user.profile_done === '0') {
    items.push({ key: 'finish', to: '/myaccount/complete_profile', IconCmp: I.CheckCircle, label: 'Finish Profile Setup' });
  }
  items.push({ key: 'profile', to: '/myaccount/profile', IconCmp: I.User, label: 'My Profile' });

  if (user.user_role === '1' && user.profile_done === '1') {
    items.push({ key: 'upgrade', to: '/myaccount/upgradeprofile', IconCmp: I.ArrowUp, label: 'Upgrade Profile' });
  }
  if (user.user_role === '2' && user.category_ids !== '6' && user.category_ids !== '7' && user.profile_done === '1') {
    items.push(
      { key: 'prods', to: '/myaccount/my_prods_servs', IconCmp: I.List, label: 'My Products / Services' },
      { key: 'subs', to: '/myaccount/subscription', IconCmp: I.Card, label: 'My Subscription' },
    );
  }
  items.push({ key: 'bookmarks', to: '/myaccount/my_bookmarks', IconCmp: I.Bookmark, label: 'Eng Info Bookmarks' });

  if (user.user_role === '2' && user.profile_done === '1') {
    items.push({
      key: 'contacted',
      to: '/myaccount/contacted_customers',
      IconCmp: I.Users,
      label: `Contacted ${(user.category_ids === '6' || user.category_ids === '7') ? 'Users' : 'Customers'}`,
    });
  }
  items.push({ key: 'history', to: '/myaccount/contact_history', IconCmp: I.History, label: 'Contact History' });

  if (user.user_role === '2' && user.profile_done === '1') {
    items.push({ key: 'catchange', to: '/myaccount/request_category_change', IconCmp: I.Switch, label: 'Request Category Change' });
  }
  if (user.profile_done === '1') {
    items.push({ key: 'update', to: '/myaccount/updatedetails', IconCmp: I.Edit, label: 'Update Details' });
  }
  items.push({ key: 'pwd', to: '/myaccount/updatepassword', IconCmp: I.Lock, label: 'Update Password' });
  items.push({ key: 'div' });
  items.push({ key: 'logout', onClick: () => { onClose(); logout(); }, IconCmp: I.Logout, label: 'Logout', danger: true });

  return items;
}

/* ─────────── mobile drawer ─────────── */
function Drawer({ open, onClose, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[1200]" role="dialog" aria-modal="true">
      <button type="button" aria-label="Close menu" onClick={onClose} className="absolute inset-0 bg-black/72 backdrop-blur-md animate-[fadeIn_180ms_ease-out]" />
      <aside
        className="
          absolute right-0 top-0 bottom-0 w-[85%] max-w-[340px]
          bg-surface-paper border-l border-amber/24
          shadow-dialog flex flex-col
          animate-[fadeIn_220ms_ease-out]
        "
        style={{ boxShadow: '-24px 0 64px -12px rgba(0,0,0,0.8)' }}
      >
        <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/60 to-transparent" />
        {children}
      </aside>
    </div>
  );
}

function DrawerSection({ kicker }) {
  return (
    <div className="px-3.5 pt-4 pb-1.5 inline-flex items-center gap-1.5">
      <span aria-hidden className="inline-flex h-1 w-1 rounded-full bg-amber" />
      <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-amber">{kicker}</span>
    </div>
  );
}

function DrawerNavItem({ to, onClick, IconCmp, label, isActive, expandable, expanded, danger }) {
  const Tag = to ? Link : 'button';
  const props = to ? { to } : { type: 'button' };
  return (
    <Tag
      {...props}
      onClick={onClick}
      className={`
        group relative flex w-full items-center gap-2.5 rounded-lg px-3 py-2.5
        text-[13px] font-semibold text-left
        transition-[background-color,color] duration-200 ease-out-soft
        ${danger
          ? 'text-red-400 hover:bg-red-400/10'
          : isActive
            ? 'bg-amber/12 text-amber'
            : 'text-fg-secondary hover:bg-amber/8 hover:text-amber'}
      `}
    >
      {isActive && (
        <span aria-hidden className="absolute -left-1 top-1/2 h-[60%] w-[3px] -translate-y-1/2 rounded-r-full bg-amber" />
      )}
      <span className={`
        inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg
        ${danger
          ? 'bg-red-400/10'
          : isActive
            ? 'bg-amber/15'
            : 'bg-surface-overlay/60 group-hover:bg-amber/12'}
      `}>
        <IconCmp className="h-4 w-4" />
      </span>
      <span className="flex-1 truncate">{label}</span>
      {expandable && (
        <I.ChevronDown
          className={`h-4 w-4 shrink-0 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
        />
      )}
    </Tag>
  );
}

function DrawerSubItem({ to, onClick, IconCmp, label, danger }) {
  const Tag = to ? Link : 'button';
  const props = to ? { to } : { type: 'button' };
  return (
    <Tag
      {...props}
      onClick={onClick}
      className={`
        flex w-full items-center gap-2 rounded-lg px-3 py-2 ml-3
        text-[12.5px]
        transition-[background-color,color] duration-200
        ${danger
          ? 'text-red-400 hover:bg-red-400/10'
          : 'text-fg-secondary hover:text-amber hover:bg-amber/8'}
      `}
    >
      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md ${danger ? 'bg-red-400/10' : 'bg-amber/8 text-amber'}`}>
        <IconCmp className="h-3 w-3" />
      </span>
      <span className="truncate">{label}</span>
    </Tag>
  );
}

/* ═════════════════════════ component ═════════════════════════ */

export const Navbar = (props) => {
  const location = useLocation();
  const history = useNavigate();
  const cats = props?.cats;
  const { user, setUser } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);

  // Reactive `loc` so navbar links pick up the user's location once the
  // geolocation prompt resolves (App.js dispatches 'esay:locchange').
  const [loc, setLoc] = useState(localStorage.getItem('loc') || '');
  useEffect(() => {
    const sync = () => setLoc(localStorage.getItem('loc') || '');
    window.addEventListener('esay:locchange', sync);
    return () => window.removeEventListener('esay:locchange', sync);
  }, []);

  const [wait, setWait] = useState(false);

  const catBtnRef = useRef(null);
  const accBtnRef = useRef(null);
  const [catOpen, setCatOpen] = useState(false);
  const [accOpen, setAccOpen] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerCatOpen, setDrawerCatOpen] = useState(false);
  const [drawerAccOpen, setDrawerAccOpen] = useState(false);

  const [quickSearchOpen, setQuickSearchOpen] = useState(false);
  const [quickSearchText, setQuickSearchText] = useState('');

  // Close popovers / drawer on route change
  useEffect(() => {
    setCatOpen(false);
    setAccOpen(false);
    setDrawerOpen(false);
  }, [location.pathname]);

  const logout = () => {
    setWait(true);
    setAccOpen(false);
    const tkn = localStorage.getItem('estkn');
    Axios.get('/new_apis/logout', { headers: { tkn } }).then((res) => {
      setUser(null);
      setWait(false);
      localStorage.removeItem('estkn');
      history('/');
      setSnack({
        message: res?.data?.status ? 'Logged out successfully.' : 'Something went wrong.',
        type: res?.data?.status ? 'success' : 'error',
        open: true,
        direction: 'left',
      });
    }).catch(() => {
      setUser(null);
      setWait(false);
      localStorage.removeItem('estkn');
      history('/');
    });
  };

  const activePaths = {
    categories: ['/searchresults/*', '/psdetails/*', '/ewdetails/*'],
    engInfo:    ['/eng-info/*'],
    trends:     ['/trends', '/trends-list', '/trends-list/*'],
    conversions:['/conversions', '/conversions-list/*'],
    careers:    ['/careers', '/job-details/*'],
    account:    ['/myaccount/*', '/login', '/signup'],
  };

  const accountItems = buildAccountItems(user, () => setAccOpen(false), logout);

  const drawerAccountItems = buildAccountItems(user, () => setDrawerOpen(false), logout);

  return (
    <>
      {/* Sticky navbar bar.
         IMPORTANT: backdrop-filter creates a containing block for fixed-position
         descendants - meaning any drawer/popover rendered INSIDE this <header>
         would get clamped to the navbar height instead of going full-viewport.
         So the drawer, popovers, QuickSearch and BackDropLoad are rendered as
         siblings of the header (below) - never inside it. */}
      <header
        id="back-to-top-anchor"
        className="
          sticky top-0 z-[1000]
          bg-[rgba(8,8,10,0.78)] text-fg-primary
          border-b border-amber/15
        "
        style={{
          backdropFilter: 'blur(20px) saturate(1.5)',
          WebkitBackdropFilter: 'blur(20px) saturate(1.5)',
        }}
      >
      <div className="mx-auto w-full max-w-[1320px] px-3 sm:px-5 lg:px-6">
        <div className="relative flex h-[72px] items-center">
          {/* Logo - restrained, premium, with quiet ambient life */}
          <Link to="/" aria-label="ESAY Home" className="group relative inline-flex items-center mr-2">
            {/* Soft amber halo - gentle breathing, brighter on hover */}
            <span
              aria-hidden
              className="
                pointer-events-none absolute inset-0 -z-10 rounded-full
                bg-amber/30 blur-2xl
                transition-opacity duration-500 ease-out-soft
                group-hover:!opacity-100
              "
              style={{ animation: 'esay-logo-breathe 4.5s ease-in-out infinite' }}
            />
            <img
              src="/assets/ESAY.png"
              alt="ESAY"
              className="
                relative h-16 w-16 object-contain
                transition-[transform,filter] duration-400 ease-out-soft
                [filter:drop-shadow(0_2px_10px_rgba(251,191,36,0.3))]
                group-hover:scale-[1.06]
                group-hover:[filter:drop-shadow(0_4px_18px_rgba(251,191,36,0.65))]
              "
            />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex ml-auto items-center gap-0.5">
            <DesktopNav
              IconCmp={I.List}
              hasCaret
              ariaHasPopup="true"
              ariaExpanded={catOpen ? 'true' : 'false'}
              isActive={matchesAny(location.pathname, activePaths.categories)}
              onClick={(e) => { catBtnRef.current = e.currentTarget; setCatOpen((v) => !v); setAccOpen(false); }}
            >
              Categories
            </DesktopNav>
            <DesktopNav
              IconCmp={I.Book}
              to="/eng-info/home"
              isActive={matchesAny(location.pathname, activePaths.engInfo)}
            >
              Eng Info
            </DesktopNav>
            <DesktopNav
              IconCmp={I.Trend}
              to="/trends"
              isActive={matchesAny(location.pathname, activePaths.trends)}
            >
              Trends
            </DesktopNav>
            <DesktopNav
              IconCmp={I.Ruler}
              to="/conversions-list/length"
              isActive={matchesAny(location.pathname, activePaths.conversions)}
            >
              Conversions
            </DesktopNav>
            <DesktopNav
              IconCmp={I.Briefcase}
              to="/careers"
              isActive={matchesAny(location.pathname, activePaths.careers)}
            >
              Careers
            </DesktopNav>
            <DesktopNav
              IconCmp={I.Search}
              onClick={() => setQuickSearchOpen(true)}
            >
              Search
            </DesktopNav>
            <DesktopNav
              IconCmp={I.User}
              hasCaret
              ariaHasPopup="true"
              ariaExpanded={accOpen ? 'true' : 'false'}
              isActive={matchesAny(location.pathname, activePaths.account)}
              onClick={(e) => { accBtnRef.current = e.currentTarget; setAccOpen((v) => !v); setCatOpen(false); }}
            >
              Account
            </DesktopNav>
          </nav>

          {/* Mobile hamburger */}
          <button
            type="button"
            onClick={() => setDrawerOpen(true)}
            aria-label="Open menu"
            className="
              md:hidden ml-auto inline-flex h-10 w-10 items-center justify-center rounded-lg
              border border-amber/24 bg-surface-elevated text-amber
              transition-[background-color,border-color,color,box-shadow] duration-200 ease-out-soft
              hover:bg-amber/10 hover:border-amber/50
              hover:shadow-[0_0_0_3px_rgba(251,191,36,0.18)]
            "
          >
            <I.Menu className="h-5 w-5" />
          </button>
        </div>
      </div>

      {/* Amber gradient hairline */}
      <span aria-hidden className="pointer-events-none absolute left-1/2 -bottom-px h-px w-[min(640px,60%)] -translate-x-1/2 bg-gradient-to-r from-transparent via-amber to-transparent" style={{ opacity: 0.6 }} />
      </header>

      <BackDropLoad wait={wait} />
      <QuickSearch
        open={quickSearchOpen}
        closeqs={() => setQuickSearchOpen(false)}
        openqs={() => setQuickSearchOpen(true)}
        searchtext={quickSearchText}
        settext={setQuickSearchText}
      />

      {/* Categories popover */}
      <Popover open={catOpen} anchor={catBtnRef.current} onClose={() => setCatOpen(false)}>
        {cats
          ? cats.map((cat) => (
              <PopoverItem
                key={cat.category_id}
                to={`/searchresults/${loc}/${cat.category_id}`}
                IconCmp={I.ChevronRight}
                onClick={() => setCatOpen(false)}
              >
                {cat.category_name}
              </PopoverItem>
            ))
          : Array.from({ length: 5 }).map((_, i) => (
              <div key={`skel-${i}`} className="flex items-center gap-2.5 px-3 py-2">
                <Skeleton variant="circle" width={28} height={28} />
                <Skeleton variant="text" width={`${60 + (i * 8) % 40}%`} height={12} />
              </div>
            ))
        }
      </Popover>

      {/* Account popover */}
      <Popover open={accOpen} anchor={accBtnRef.current} onClose={() => setAccOpen(false)} align="right">
        {accountItems.map((it) => {
          if (it.key === 'div') return <div key="div" className="my-1 mx-3 border-t border-border-subtle" />;
          return (
            <PopoverItem
              key={it.key}
              to={it.to}
              onClick={it.onClick || (() => setAccOpen(false))}
              IconCmp={it.IconCmp}
              danger={it.danger}
            >
              {it.label}
            </PopoverItem>
          );
        })}
      </Popover>

      {/* Mobile drawer */}
      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        {/* Header */}
        <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-border-subtle">
          <Link to="/" onClick={() => setDrawerOpen(false)} aria-label="ESAY Home" className="inline-flex items-center gap-2.5">
            <img src="/assets/ESAY.png" alt="ESAY" className="h-10 w-10 object-contain" />
            <span className="text-[18px] font-extrabold tracking-[-0.02em] text-fg-primary">ESAY</span>
          </Link>
          <button
            type="button"
            onClick={() => setDrawerOpen(false)}
            aria-label="Close menu"
            className="
              inline-flex h-9 w-9 items-center justify-center rounded-full
              text-fg-tertiary
              transition-[background-color,color] duration-200
              hover:bg-surface-overlay hover:text-amber
            "
          >
            <I.Close className="h-4 w-4" />
          </button>
        </div>

        {/* Navigation */}
        <div className="flex-1 overflow-y-auto px-2 py-2">
          <DrawerSection kicker="Browse" />
          <div className="flex flex-col gap-0.5">
            <DrawerNavItem
              IconCmp={I.List}
              label="Categories"
              isActive={matchesAny(location.pathname, activePaths.categories)}
              expandable
              expanded={drawerCatOpen}
              onClick={() => setDrawerCatOpen((v) => !v)}
            />
            <div
              className={`grid transition-[grid-template-rows] duration-300 ease-out-soft ${drawerCatOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
            >
              <div className="overflow-hidden">
                <div className="flex flex-col gap-0.5 py-1">
                  {cats
                    ? cats.map((cat) => (
                        <DrawerSubItem
                          key={cat.category_id}
                          to={`/searchresults/${loc}/${cat.category_id}`}
                          onClick={() => setDrawerOpen(false)}
                          IconCmp={I.ChevronRight}
                          label={cat.category_name}
                        />
                      ))
                    : Array.from({ length: 5 }).map((_, i) => (
                        <div key={`mskel-${i}`} className="flex items-center gap-2 ml-3 px-3 py-2">
                          <Skeleton variant="circle" width={20} height={20} />
                          <Skeleton variant="text" width={`${50 + (i * 7) % 40}%`} height={12} />
                        </div>
                      ))}
                </div>
              </div>
            </div>

            <DrawerNavItem
              to="/eng-info/home"
              onClick={() => setDrawerOpen(false)}
              IconCmp={I.Book}
              label="Eng Info"
              isActive={matchesAny(location.pathname, activePaths.engInfo)}
            />
            <DrawerNavItem
              to="/trends"
              onClick={() => setDrawerOpen(false)}
              IconCmp={I.Trend}
              label="Trends"
              isActive={matchesAny(location.pathname, activePaths.trends)}
            />
            <DrawerNavItem
              to="/conversions-list/length"
              onClick={() => setDrawerOpen(false)}
              IconCmp={I.Ruler}
              label="Conversions"
              isActive={matchesAny(location.pathname, activePaths.conversions)}
            />
            <DrawerNavItem
              to="/careers"
              onClick={() => setDrawerOpen(false)}
              IconCmp={I.Briefcase}
              label="Careers"
              isActive={matchesAny(location.pathname, activePaths.careers)}
            />
            <DrawerNavItem
              IconCmp={I.Search}
              label="Search"
              onClick={() => { setDrawerOpen(false); setQuickSearchOpen(true); }}
            />
          </div>

          <div className="my-3 mx-2 border-t border-border-subtle" />

          <DrawerSection kicker="Account" />
          <DrawerNavItem
            IconCmp={I.User}
            label={user ? (user.name || user.fname || 'My account') : 'Account'}
            isActive={matchesAny(location.pathname, activePaths.account)}
            expandable
            expanded={drawerAccOpen}
            onClick={() => setDrawerAccOpen((v) => !v)}
          />
          <div
            className={`grid transition-[grid-template-rows] duration-300 ease-out-soft ${drawerAccOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
          >
            <div className="overflow-hidden">
              <div className="flex flex-col gap-0.5 py-1">
                {drawerAccountItems.map((it) => {
                  if (it.key === 'div') return <div key="div" className="my-1 mx-3 border-t border-border-subtle" />;
                  return (
                    <DrawerSubItem
                      key={it.key}
                      to={it.to}
                      onClick={it.onClick || (() => setDrawerOpen(false))}
                      IconCmp={it.IconCmp}
                      label={it.label}
                      danger={it.danger}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};
